<div class="d-flex flex-column align-items-center">
    <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[900px] overflow-auto max-h-[80vh]">
        <div class="d-flex flex-column align-items-end" (click)="close()"> <span style="cursor: pointer;">&times;</span>
        </div>
        <h5>Examination Period Report</h5>

        <form class="mr-0" (ngSubmit)="getResultReport()" *ngIf="!exportedFile.file">
            <div class="row">
                <div class="mb-3 mr-0 col-md-6">
                    <label class="form-label">Period</label>
                    <input class="form-control" type="text" [(ngModel)]="period"
                        [ngModelOptions]="{ standalone: true }">
                </div>
                <div class="mb-3 mr-0 col-md-6">
                    <label class="form-label">Date Of Writing</label>
                    <input class="form-control" type="date" [(ngModel)]="dateOfWriting" [ngModelOptions]="{ standalone: true }">
                </div>
            </div>
            <div class="row">
                <div class="mb-3 mr-0 col-md-4">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="skipImportCandidateData"
                        [ngModelOptions]="{ standalone: true }">
                    <label class="form-check-label ml-1" for="flexCheckDefault">
                        Skip Import Candidate Data
                    </label>
                </div>
                <div class="mb-3 mr-0 col-md-4">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="excludeTestCandidates"
                        [ngModelOptions]="{ standalone: true }">
                    <label class="form-check-label ml-1" for="flexCheckDefault">
                        Exclude Test Candidates
                    </label>
                </div>
                <div class="mb-3 mr-0 col-md-4">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="includeContactDetails"
                        [ngModelOptions]="{ standalone: true }">
                    <label class="form-check-label ml-1" for="flexCheckDefault">
                        Include Contact Details
                    </label>
                </div>
            </div>
            <button class="btn btn-primary btn-lg col-md-12" type="submit"> Generate Report
            </button>
        </form>
        <app-file-download *ngIf="exportedFile.file" [exportedFile]="exportedFile"></app-file-download>
    </div>
</div>